module.exports = "<ng-template [ngIf]=\"!isLoading\">\n    <div class=\"user-define-popup-container\">\n        <lfwms-result-data-table [searchService]=\"searchService\" [tableMode]=\"tableMode\"\n            (buttonActionHandler)=\"handleButtonAction($event)\">\n        </lfwms-result-data-table>\n    </div>\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/common/userdefinefields-popup/user-define-popup.component.html
// module id = ../../../../../src/app/shared/components/common/userdefinefields-popup/user-define-popup.component.html
// module chunks = main